import React, { useState } from "react";
import angledown from "../static/images/component_svg/angle-down.svg";
import styles from "./LevelResult.module.css";

function LevelResult(props) {
  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState);
  };

  return (
    <div>
      <div className={styles.headtext}>ผลการทดสอบ</div>
      <div className={styles.resultbox}>
        <div className={styles.headresultbox} onClick={toggleVisibility}>
          <div>{props.name}</div>
          <img
            className={`${styles.arrow} ${isVisible ? styles.arrowActive : ""}`}
            src={angledown}
            alt="downArrow"
          />
        </div>
        <div
          className={`${styles.bodyresultbox} ${isVisible ? styles.open : ""}`}
        >
          <div className={styles.text}>คะแนนของคุณ</div>
          <div className={styles.score}>
            {props.score + "/" + props.fullscore}
          </div>
          <div className={styles.text}>เวลาเฉลี่ยของคุณ</div>
          <div className={styles.scorebottom}>{props.time} วินาที</div>
        </div>
      </div>
    </div>
  );
}

export default LevelResult;
